import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Fab, Tooltip } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

export default function BottomScannerBar() {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if we're on one of the pages where the scanner bar should appear
  const shouldShowScannerBar = () => {
    const scannerPages = ['/', '/myaccount', '/blockchain', '/claim', '/nft'];
    return scannerPages.some(page => location.pathname.startsWith(page));
  };

  const handleScanClick = () => {
    navigate('/scanner');
  };

  if (!shouldShowScannerBar()) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
      }}
    >
      <Tooltip title="Scan QR Code" placement="left">
        <Fab
          color="primary"
          aria-label="scan"
          onClick={handleScanClick}
          sx={{
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
            },
          }}
        >
          <QrCodeScannerIcon />
        </Fab>
      </Tooltip>
    </Box>
  );
} 